import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getFooterData = createAsyncThunk('footerData/getFooterData', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getFooter();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
